import React from 'react';

const About = () => {
    return (
        <div>
           <div className='container'>
               <img style={{width:"500px", height: "450px"}} src="https://i.ibb.co/4F2PHfX/myphoto.png" alt="" />
               <div className='w-50'>
                   <h3 className='text-center mt-5'>My Destination</h3>
                   <h5>The goals I choose to pursue can help Me in the Future. Establish career expectations. Web developers can decide on a direction and establish where to take their career by setting goals. For bright career I choos Web development for make me skilled one. My mentors help to improve my skill. After Complete these development course I will continue my career with this sector.</h5>
               </div>
           </div>
        </div>
    );
};

export default About;<h2>About me</h2>